const mode = "dev";
// let a = "../config/" + mode + ".json";
const config = require(`../config/${mode}.json`);
module.exports = {
    CALLBACK_URL_COUPON: `${window.location.origin}/#/order-status`,
    LOCAL_MALL_BASE_API: "https://localmallcatalog.mall91.com",
    FILE_UPLOAD_URL: "https://media.getzyk.com/uploadMediaFile/8",
    BASE_URL2: 'https://billsbe.payboard.in/api/v1/',
    BASE_API_URL: config.BASE_API
}